// Elements that require template selection
export const TEMPLATE_ELEMENT_KEYS = ['hero', 'component'];

// Grouped element types for organized display
export const ELEMENT_TYPE_GROUPS = [
  {
    title: 'Templates',
    description: 'Choose a template',
    elements: [
      { key: 'hero', label: 'Hero', description: 'Full-width banner section' },
      { key: 'component', label: 'Component', description: 'Nested container' },
    ]
  },
  {
    title: 'Quick Add',
    description: 'Add directly',
    elements: [
      { key: 'button_collection', label: 'Button Collection', description: 'Multiple buttons' },
      { key: 'title', label: 'Title', description: 'Heading text' },
      { key: 'text', label: 'Text', description: 'Paragraph content' },
      { key: 'button', label: 'Button', description: 'Call-to-action button' },
      { key: 'image', label: 'Image', description: 'Photo or graphic' },
      { key: 'video', label: 'Video', description: 'Video embed or upload' },
      { key: 'file', label: 'File', description: 'Downloadable file' },
    ]
  }
];

// Flat list for backward compatibility
export const ELEMENT_TYPES = [
  { key: 'hero', label: 'Hero', description: 'Full-width banner section' },
  { key: 'title', label: 'Title', description: 'Heading text' },
  { key: 'text', label: 'Text', description: 'Paragraph content' },
  { key: 'button', label: 'Button', description: 'Call-to-action button' },
  { key: 'button_collection', label: 'Button Collection', description: 'Multiple buttons' },
  { key: 'component', label: 'Component', description: 'Nested container' },
  { key: 'image', label: 'Image', description: 'Photo or graphic' },
  { key: 'video', label: 'Video', description: 'Video embed or upload' },
  { key: 'file', label: 'File', description: 'Downloadable file' },
];

// DEPRECATED: Custom panels removed - image, video, file now create directly with placeholders
// export const CUSTOM_PANEL_TYPES = ['image', 'video', 'file'];
